export default {
  computed: {
    mSubtopikKoordinator() {
      const master = Object.assign({}, this.$getDeepObj(this.masters, 'koordinator_subtopik_psp') || {});

      return Object.keys(master)
        .filter((key) => +master[key][0] === +this.form.k_koordinator_topik_psp)
        .map((key) => {
          return {
            text: master[key][1],
            value: +key,
          };
        });
    },

    schemaProgres2023() {
      const bulan = this.$getDeepObj(this.info, 'bulan') || '';
      const urutan = {
        1: 'Urutan Pertama',
        2: 'Urutan Kedua',
        3: 'Urutan Ketiga',
      };

      return {
        dasar: {
          title: 'Informasi Dasar Kegiatan',
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Urutan topik yang dibicarakan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: urutan[this.progresId] || '',
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'k_koordinator_topik_psp',
              label: 'Topik yang dibicarakan',
              placeholder: 'Pilih Topik',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'koordinator_topik_psp') || {}),
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              required: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VAutocomplete',
              name: 'k_koordinator_subtopik_psp',
              label: 'Subtopik dari Topik yang dibicarakan',
              placeholder: 'Pilih Subtopik',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              slot: 'selection',
              items: this.mSubtopikKoordinator || [],
              grid: { cols: 12, md: 6 },
              multiple: true,
              outlined: true,
              dense: true,
              required: true,
              singleLine: true,
              hideDetails: true,
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'refleksi',
              label: 'Gambaran umum hasil refleksi sekolah mengapa memilih topik tersebut.',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi (maksimal 50 kata)',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              required: true,
              counter: 50,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'masalah',
              label: 'Gambaran umum akar masalah terhadap topik-topik yang dibahas.',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi (maksimal 50 kata)',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              required: true,
              counter: 50,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'solusi',
              label: 'Gambaran umum solusi dan tindak lanjut yang dilakukan sekolah terhadap topik yang dipilih.',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi (maksimal 50 kata)',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              required: true,
              counter: 50,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'tindak_lanjut',
              label: 'Usulan tindak lanjut yang perlu dilakukan serta penanggung jawab.',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi (maksimal 50 kata)',
              hint: 'wajib diisi',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              required: true,
              counter: 50,
              counterValue: (v) => this.$wordCount(v),
            },
          ],
        },
      };
    },
  },
};
